module.exports = __webpack_public_path__ + "img/a11y-support_cn.184282a.jpg";